export { CorporativoOnboardingTutorialEasyRegional } from "./CorporativoOnboardingTutorialEasyRegional";
